import React from 'react';
import { IonAvatar } from '@ionic/react';
import { UserAvatarContainer } from './searchHeaderStyles';
import { NavLink } from 'react-router-dom';
import { useAppSelector } from '../../../state/hooks';
import { RootState } from '../../../state/store';
import { shallowEqual } from 'react-redux';

const UserAvatar: React.FC = () => {
	const user_prefs = useAppSelector(
		(state: RootState) => state.prefs,
		shallowEqual,
	);
	const avatar = useAppSelector(
		(state: RootState) => state.avatar,
		shallowEqual,
	);
	return (
		<UserAvatarContainer>
			<h1 className="ma0">
				Hello, {user_prefs.name ? user_prefs.name : 'Explorer'}
			</h1>
			<NavLink to="/profile">
				<div>
					<img alt="User avatar" src={user_prefs.avatar} />
				</div>
			</NavLink>
		</UserAvatarContainer>
	);
};

export default UserAvatar;
